<template>
  <v-dialog
    v-model="dialogframeboton"
    persistent
    :fullscreen="componenteview != 2 ? true : false"
    :width="componenteview == 2 ? '1000px' : ''"
  >
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }} -
          {{ infoitem.DescTypeDocument_ID }}-{{ infoitem.Document_ID }} -
          {{ infoitem.Nombre }} {{ infoitem.Nombre_2 }}
          {{ infoitem.Apellido_1 }} {{ infoitem.Apellido_2 }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="dialogframeboton = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!--Direcciones ¡-->
        <card-direcciones
          v-if="componenteview == 1"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :typedocument="infoitem.TypeDocumentID.toString()"
          :document="infoitem.DocumentID"
        ></card-direcciones>
        <!--Nuevo Documento ¡-->
        <card-nuevocontacto
          v-else-if="componenteview == 2"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :typedocument="infoitem.TypeDocumentID.toString()"
          :document="infoitem.DocumentID"
        ></card-nuevocontacto>
        <!-- Riesgos ¡-->
        <card-riesgos
          v-else-if="componenteview == 3"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :typedocument="infoitem.TypeDocumentID.toString()"
          :document="infoitem.DocumentID"
        ></card-riesgos>
        <!-- Consulta  Contratos ¡-->
        <card-contratos
          v-else-if="componenteview == 4"
          :infollaves="llaves"
          :infopermisos="permisobutton"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
        ></card-contratos>
        <!-- Consulta  Activos ¡-->
        <card-activos
          v-else-if="componenteview == 5"
          :infollaves="llaves"
          :infopermisos="permisobutton"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
        ></card-activos>
        <!-- Consulta  Seguros ¡-->
        <card-seguros
          v-else-if="componenteview == 6"
          :infollaves="llaves"
          :infopermisos="permisobutton"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
        ></card-seguros>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Tablero de control -->
  <v-data-table
    v-model="selected"
    v-model:page="itemsPerPage"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="index"
    show-select
    return-object
    height="550px"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <!-- Campos -->
        <v-dialog v-model="dialogframecreate" persistent max-width="1500px">
          <template v-if="param1[1] == '1'" v-slot:activator="{ props }">
            <v-btn
              color="green"
              icon="mdi-plus"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>{{ iconTitle }}</v-icon> {{ formTitle }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="
                    dialogframecreate = false;
                    editedItem = null;
                    editedIndex = -1;
                  "
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <proceso-registro
                v-if="dialogframecreate"
                :infoedit="editedItem"
                v-bind:page="dialogframecreate"
                v-on:update:page="dialogframecreate = $event"
                v-bind:Exito="respuestapostput"
                v-on:update:Exito="respuestapostput = $event"
                v-bind:componenteview="componenteview"
                v-on:update:componenteview="componenteview = $event"
                v-bind:pageiframe="dialogframeboton"
                v-on:update:pageiframe="dialogframeboton = $event"
                v-bind:titledialogbtn="titledialogbtn"
                v-on:update:titledialogbtn="titledialogbtn = $event"
                v-bind:iconodialogbtn="iconodialogbtn"
                v-on:update:iconodialogbtn="iconodialogbtn = $event"
                :infopermisos="param1"
                :editedIndex="editedIndex"
                :infollaves="infollaves"
              ></proceso-registro>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider
          v-if="param1[1] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Eliminación -->
        <v-btn
          v-if="param1[3] == '1'"
          color="red"
          icon="mdi-delete"
          dark
          class="mb-2"
          @click="Eliminar"
        >
        </v-btn>
        <v-divider
          v-if="param1[3] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Filtros -->
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn class="d-none d-md-block" dark text @click="reset"
                  >Limpiar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="ValidateCampos"
                  >Consultar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="dialogframe = false"
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>
                  <!-- Contenido -->
                  <v-col v-if="i >= 4 && i < 9" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayComunicacion"
                      :item-title="
                        (ArrayComunicacion) =>
                          ArrayComunicacion.Valor +
                          '-' +
                          ArrayComunicacion.Descripcion
                      "
                      item-value="Valor"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else-if="i >= 9 || i == 3" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArraySiNo"
                      :item-title="
                        (ArraySiNo) =>
                          ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                      "
                      item-value="Valor"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :type="i == 7 || i == 8 || i == 9 ? 'date' : ''"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-center">
        <v-menu
          v-model="menubuttoms[item.raw.index]"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ props }">
            <v-icon color="red-darken-4" v-bind="props">
              mdi-file-settings</v-icon
            >
          </template>
          <v-card flat>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- Modificación  -->
                  <v-tooltip
                    v-if="param1[2] == '1' || param1[0] == '1'"
                    location="bottom"
                    color="white"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        color="#05AD58"
                        @click="editItem(item.raw, 0)"
                        v-bind="props"
                        >{{
                          param1[2] == "1" && param1[0] == "0"
                            ? "mdi-pencil"
                            : "mdi-eye"
                        }}</v-icon
                      >
                    </template>
                    <span>{{
                      param1[2] == "1" && param1[0] == "0"
                        ? "Modificar"
                        : "Consultar"
                    }}</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Direcciones -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 1)"
                        color="blue"
                        v-bind="props"
                        >mdi-map-marker-plus</v-icon
                      >
                    </template>
                    <span>Direcciones</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Nuevo Contacto -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 2)"
                        color="orange"
                        v-bind="props"
                        >mdi-account-multiple-plus</v-icon
                      >
                    </template>
                    <span>Nuevo Contacto</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Riesgos -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 3)"
                        color="red"
                        v-bind="props"
                        >mdi-lock-alert</v-icon
                      >
                    </template>
                    <span>Riesgos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Contrato -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 4)"
                        color="red"
                        v-bind="props"
                        >mdi-note</v-icon
                      >
                    </template>
                    <span>Contrato</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Activos -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 5)"
                        color="cyan"
                        v-bind="props"
                        >mdi-home-group</v-icon
                      >
                    </template>
                    <span>Activos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Seguros -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 6)"
                        color="cyan"
                        v-bind="props"
                        >mdi-account-lock</v-icon
                      >
                    </template>
                    <span>Seguros</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Anexar Documento -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon color="indigo" v-bind="props"
                        >mdi-folder-open</v-icon
                      >
                    </template>
                    <span>Anexar Documento</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Consultar Documento -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon color="purple" v-bind="props"
                        >mdi-file-search</v-icon
                      >
                    </template>
                    <span>Consulta documentos</span>
                  </v-tooltip>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </template>
    <!-- Documentos  -->
    <template v-slot:item.DocumentID="{ item }">
      <div class="text-center">
        <span>{{ item.raw.DescTypeDocumentID }}-{{ item.raw.DocumentID }}</span>
      </div>
    </template>
    <!-- Nombre Completo  -->
    <template v-slot:item.Nombre="{ item }">
      <div>
        <span
          >{{ item.raw.Nombre }} {{ item.raw.Nombre2 }}
          {{ item.raw.Apellido1 }} {{ item.raw.Apellido2 }}</span
        >
      </div>
    </template>
    <!-- Bloqueo por Riesgo  -->
    <template v-slot:item.BloqRiesgo="{ item }">
      <div class="text-center">
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              :color="
                item.raw.BloqRiesgo == '1'
                  ? '#FE8B00'
                  : item.raw.BloqRiesgo == '2'
                  ? '#FE0000'
                  : 'grey-lighten-1'
              "
              v-bind="props"
            >
              {{
                item.raw.BloqRiesgo == "1"
                  ? "mdi-car-brake-alert"
                  : item.raw.BloqRiesgo == "2"
                  ? "mdi-lock-alert"
                  : "mdi-clock-alert-outline"
              }}
            </v-icon>
          </template>
          <span>
            {{
              item.raw.BloqRiesgo == "1"
                ? "Riesgo activo"
                : item.raw.BloqRiesgo == "2"
                ? "Bloqueado por riesgo"
                : "Sin Riesgo Activo"
            }}
          </span>
        </v-tooltip>
      </div>
    </template>
  </v-data-table>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Registro from "@/views/TCI/Personas/Clientes/ClientesRegistro.vue";
import Direcciones from "@/views/TCI/Personas/Direcciones/Direcciones.vue";
import NuevoContacto from "@/views/TCI/Personas/NuevoContacto/NuevoContacto.vue";
import Riesgos from "@/views/TCI/Personas/Riesgos/Riesgos.vue";
import Activos from "@/views/TCI/ActivosO/Activos/Activos.vue";
import Seguros from "@/views/TCI/ActivosO/Seguros/Seguros.vue";
import Contrato from "@/views/TCI/ActivosO/Contratos/Contratos.vue";
export default {
  name: "Clientes",
  props: {
    infollaves: {
      type: Object,
      default: [],
      Description: "Información de llaves",
    },
    infopermisos: {
      type: String,
      default: "0111",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
  },
  components: {
    "proceso-registro": Registro,
    "card-direcciones": Direcciones,
    "card-nuevocontacto": NuevoContacto,
    "card-riesgos": Riesgos,
    "card-activos": Activos,
    "card-contratos": Contrato,
    "card-seguros": Seguros,
  },
  data() {
    return {
      itemsPerPage: 1,
      permisobutton: "0111",
      selected: [],
      search: "",
      respuestapostput: "",
      consult: false,
      editedItem: null,
      editedIndex: -1,
      progreso: false,
      dialogframe: false,
      dialogframecreate: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      infoitem: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      modelfiltro: [
        {
          campo: "TypeDocumentID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo de documento:",
        },
        {
          campo: "DocumentID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Documento:",
        },
        {
          campo: "OPCliente",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Cliente:",
        },
        {
          campo: "BloqRiesgo",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Bloqueado por riesgo:",
        },
        {
          campo: "AutoEmail",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Habilitado Correo:",
        },
        {
          campo: "AutoSMS",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Habilitado SMS:",
        },
        {
          campo: "AutoPhone",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Habilitado LLamadas:",
        },
        {
          campo: "AutoRedSocial",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Habilitado Red Social:",
        },
        {
          campo: "AutoWP",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Habilitado Whatsapp:",
        },
        {
          campo: "OPTransito",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Organismi de tránsito o ATC:",
        },
        {
          campo: "Other2",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Aseguradora o entidad Financiera:",
        },
        {
          campo: "OPHacienda",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Hacienda/ Notaria/ Entes Gubernamentales/ Registro:",
        },
        {
          campo: "Other3",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Administración:",
        },
        {
          campo: "OPEPS",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "EPS:",
        },
        {
          campo: "OPARL",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "ARL:",
        },
        {
          campo: "OPETP",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "ETP:",
        },
        {
          campo: "OPConductor",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Conductor:",
        },
      ],
      headers: [
        {
          title: "Acciones",
          key: "actions",
          align: "center",
          sortable: false,
        },
        {
          title: "Documento",
          key: "DocumentID",
        },
        {
          title: "Nombre",
          key: "Nombre",
        },
        {
          title: "Clase de persona",
          key: "DescTipoPersona",
        },
        {
          title: "Bloqueo por riesgo",
          key: "BloqRiesgo",
          align: "center",
        },
      ],
      desserts: [],
      ArraySiNo: [],
      ArrayComunicacion: [],
      param1: [],
      busquedacompleta: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear Registro"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "Actualizar registro"
        : "Consultar registro";
    },
    iconTitle() {
      return this.editedIndex === -1
        ? "mdi-plus"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "mdi-pencil"
        : "mdi-eye";
    },
  },
  watch: {
    dialogframecreate(val) {
      if (!val && this.respuestapostput == "Exito" && this.consult) {
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.consult = validate;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },
    // Consulta Tablero
    async getConsultData() {
      this.desserts = [];
      this.selected = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
      };
      this.axios
        .post("/Personas/Cliente/CT0/", data)
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    // Item editar
    editItem(item, iconoelegido) {
      this.componenteview = iconoelegido;
      this.infoitem = item;
      switch (iconoelegido) {
        case 0:
          this.editedIndex = this.desserts.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.dialogframecreate = true;
          break;
        case 1: // Direcciones
          this.iconodialogbtn = "mdi-map-marker-plus";
          this.titledialogbtn = "Direcciones";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentID;
          this.llaves.Document_ID = item.DocumentID;
          break;
        case 2: //Nuevo Contacto
          this.iconodialogbtn = "mdi-account-multiple-plus";
          this.titledialogbtn = "Nuevo Contacto";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentID;
          this.llaves.Document_ID = item.DocumentID;
          break;
        case 3: //Riesgos
          this.iconodialogbtn = "mdi-lock-alert";
          this.titledialogbtn = "Riesgos";
          this.dialogframeboton = true;
          break;
        case 4: //Contrato
          this.iconodialogbtn = "mdi-note";
          this.titledialogbtn = "Contrato";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentID;
          this.llaves.Document_ID = item.DocumentID;
          break;
        case 5: //Activos
          this.iconodialogbtn = "mdi-home-group";
          this.titledialogbtn = "Activos";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentID;
          this.llaves.Document_ID = item.DocumentID;
          break;
        case 6: //Seguros
          this.iconodialogbtn = "mdi-note";
          this.titledialogbtn = "Seguros";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentID;
          this.llaves.Document_ID = item.DocumentID;
          break;
      }
    },
    // Confirmación de eliminación
    Eliminar() {
      if (this.selected.length != 0 && this.selected != null) {
        this.$swal({
          icon: "question",
          title: "Eliminar Información",
          html: "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.getDelete();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html: "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },
    // Consulta las eliminaciones
    async getDelete() {
      this.axios
        .delete("/Personas/Cliente/", { data: this.selected })
        .then((response) => {
          if (response.data === "Exito") {
            this.$swal({
              icon: "success",
              title: "Información Eliminada",
              html: "La información se ha eliminado correctamente.",
            });
            this.getConsultData();
            this.selected = [];
          } else {
            this.$swal({
              icon: "error",
              title: "Error al guardar los datos",
              html: response.data.toString(),
            });
          }
        })
        .catch((e) =>
          this.$swal({
            icon: "error",
            title:
              "No se logro la eliminación debido a que tiene datos relacionados",
            html:
              "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
              e.toString() +
              "</code></small>",
          })
        );
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
      if (this.pageiframe) {
        for (var i = 0; i < 2; i++) {
          this.modelfiltro[i].filtro = "=";
          if (i == 0) {
            this.modelfiltro[i].contenido = this.infollaves.TypeDocument_ID;
          } else if (i == 1) {
            this.modelfiltro[i].contenido = this.infollaves.Document_ID;
          }
          this.modelfiltro[i].lectura = true;
          this.modelfiltro[i].clear = false;
        }
      }
    },
    // Cargue Combo
    CargueCombo() {
      this.ArrayComunicacion = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 50
      );

      this.ArraySiNo = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 16
      );
    },
    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
      }
    },
    // Parametros Iframe
    parametrosiframe() {
      for (var i = 0; i < 2; i++) {
        this.modelfiltro[i].filtro = "=";
        if (i == 0) {
          this.modelfiltro[i].contenido = this.infollaves.TypeDocument_ID;
        } else if (i == 1) {
          this.modelfiltro[i].contenido = this.infollaves.Document_ID;
        }
        this.modelfiltro[i].lectura = true;
        this.modelfiltro[i].clear = false;
      }
      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.ValidateCampos();
    },
  },
  mounted() {
    if (!this.pageiframe) {
      this.parametrospaginas();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
